import request from '@/util/request'

//��ѯͶ����������
export function getSummary(projectId) {
    return request({
        url: `/project-s/invest/summary/${projectId}`,
		method: 'get'
    })
}

//��ȡͶ���б�
export function getList(data) {
	return request({
		url: `/project-s/invest/list`,
		method: 'get',
		params: data
	})
}

//��ѯ�༭Ͷ��
export function getInvest(projectId, id) {
	return request({
		url: `/project-s/invest/${projectId}/${id}`,
		method: 'get'
	})
}

//����༭Ͷ��
export function saveInvest(data) {
	return request({
		url: `/project-s/invest/save-invest`,
		method: 'post',
		data
	})
}

//��Ӵ�Žڵ�
export function add(data) {
	return request({
		url: `/project-s/invest/insert`,
		method: 'post',
		data
	})
}

export function update(data) {
	return request({
		url: `/project-s/invest/update`,
		method: 'post',
		data
	})
}

//ɾ��Ͷ�Žڵ�
export function del(projectId, id) {
	return request({
		url: `/project-s/invest/${projectId}/${id}`,
		method: 'delete'
	})
}



// WEBPACK FOOTER //
// ./src/api/project/invest.js